module.exports = __webpack_public_path__ + "img/distant-view-25.92e9ad3f93ba0117d49979b6726304d5.jpg";